import { Breadcrumb, Button, Card, Col, Form, Row, Select, Spin, message } from 'antd';
import React, { useEffect, useMemo, useState } from 'react'
import { getCustomisedBreadcrumbs } from '../../../../functions/functions';
import constants from '../../../../constants/constants';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import { COOKIE, getCookie } from '../../../../services/cookie';
import { fetchAdminApi } from '../../../../services/api';

const EditPodcast = () => {
	const navigate = useNavigate();
	const location = useLocation() || {};
	const [form] = Form.useForm();
	const { chapterId, entireRecord } = location.state || {};
	const [chapterid, setChapterid] = useState(chapterId);
	const [loading, setLoading] = useState(false);
	const [chapterList, setChapterList] = useState([]);

	useEffect(() => {
		const userId = getCookie(COOKIE.UserId);
		if (!userId) {
			navigate('/admin-login');
			return;
		}

		if (!entireRecord) {
			navigate('/podcast-list');
			return;
		}
		getTranscript();

		setChapterid(chapterId);
		form.setFieldsValue({
			transcript: entireRecord?.transcript || '',
		});
	}, [chapterId, entireRecord, form, navigate]);

	const changePodcastChapterid = (value) => {
		setChapterid(value);
		const chapterEdited = true;
		localStorage.setItem('chapterEdited', chapterEdited);
		localStorage.setItem('PODChapterchangeId', value);
	}

	const getChapters = async () => {
		const res = await fetchAdminApi('/chapters-list', 'get');
		if (res?.data?.length > 0) {
			const options = res.data.map((c, i) => ({ value: (i + 1).toString(), label: c.chapter }));
			localStorage.setItem('chapterDetails', JSON.stringify(options));
			setChapterList(options);
		} else {
			setChapterList([]);
		}
	};

	const submitInfo = async (values) => {
		try {
			setLoading(true);
			let payload = {
				resource_file_id:entireRecord?.resource_file_id,
				transcript:values.transcript
			}
			fetchAdminApi('/update-transcript', 'post', payload).then((res) => {
				if (res?.code === 200) {
					message.success(res?.message);
					navigate(`/podcast-list`);
					setLoading(false);
				} else {
					message.error(res?.message);
					setLoading(false);
				}
			})
		} catch (error) {
			message.error(error?.message || 'Something went wrong!');
		} finally {
			setLoading(false);
		}
	}

	const redirectBack = () => {
		navigate(-1);
	}

	const newCrumb = [
		<Link key={0} to="/podcast-list" className="font-semibold">Podcasts</Link>,
		<Link key={1} to="/edit-podcast" className="font-semibold !text-black">{entireRecord?.is_transcript === "1" ? "Edit Transcript" : "Add Transcript"}</Link>
	];

	const getTranscript = () => {
		getChapters();
		if (entireRecord?.is_transcript === "1") {
			fetchAdminApi(`/view-transcript `, 'post', { resource_file_id: entireRecord?.resource_file_id }).then((res) => {
				if (res?.code === 200) {
					form.setFieldsValue({
						transcript: res?.data?.[0]?.transcript || '',
					});
				} else {
					message.error(res?.message);
				}
			})
		}
	};

	return (
		<div className="cursorChange">
			<Row>
				<Col xs={24} sm={24} md={24} lg={24}>
					<div className='p-4 min-h-screen bg-gray-100'>
						<div>
							<Breadcrumb
								items={getCustomisedBreadcrumbs(constants.flashCardpageCrumbs, newCrumb)}
								className='bg-neutral-100 shadow-lg p-3 mb-3' />
						</div>
						<Card
							className='mainflashCard'
							title={<div className='flex-space'><span className="mr-8 uppercase">{entireRecord?.is_transcript === "1" ? "Edit Transcript" : "Add Transcript"}</span>
								<Select
									value={chapterid}
									onChange={changePodcastChapterid}
									className='w-80'
								>
									<Select.Option disabled value=""> --Chapter-- </Select.Option>
									{
										chapterList.map((each) => {
											return <Select.Option disabled key={each.value} value={each.value.toString()}> {each.label} </Select.Option>
										})
									}
								</Select>
							</div>
							}
							extra={<div className="font-medium text-xl text-pink-600">Podcast #{entireRecord?.resource_file_id}</div>}
							hoverable>
							<Spin spinning={loading} size="large" className='z-30'>
								<Form
									form={form}
									onFinish={submitInfo}
									onFinishFailed={() => message.error(constants.podcast_upload_failure)}
							>
									<Card hoverable>
										<Form.Item
											label={<span
												className="font-semibold text-base caption-item pr-2 imagecardTitle">Transcript</span>}
											className='caption-form-item'
											name="transcript"
											rules={
												[{
													required: true,
													message: 'This field is mandatory!'
												},
												{
													validator: (_, value) =>
														value && value !== "<p><br></p>" ? Promise.resolve() : Promise.reject(new Error('This field is mandatory!')),
												},
												]
											}
										>
											<ReactQuill
												theme="snow"
												modules={constants.ReactQuillModules}
												formats={constants.ReactQuillFormats}
											/>
										</Form.Item>
									</Card>
									<Button htmlType='submit' type="primary" className='mt-5 font-semibold'>Submit</Button>
									<Button type="primary" className='mt-5 ml-3 font-semibold' onClick={redirectBack}>Cancel</Button>
								</Form>
							</Spin>
						</Card>
					</div>
				</Col>
			</Row>
		</div>
	)
}

export default EditPodcast
